import type { ReactNode } from "react";

/** The camera's shape until a still reports its size. */
export const DEFAULT_ASPECT = 16 / 9;

/** A camera still; `children` overlay it exactly, since the image sizes the box. */
export const StillFrame = ({
  url,
  children,
  onLoad,
  onError,
}: {
  url: string;
  children?: ReactNode;
  /** The image's own size, for a caller with no recorded source size. */
  onLoad?: (size: { width: number; height: number }) => void;
  onError?: () => void;
}) => (
  <div
    data-dd-privacy="hidden"
    className="relative w-full overflow-hidden bg-recess"
  >
    <img
      src={url}
      alt="Camera still"
      referrerPolicy="no-referrer"
      className="block h-auto w-full"
      onError={onError}
      onLoad={
        onLoad &&
        ((event) =>
          onLoad({
            width: event.currentTarget.naturalWidth,
            height: event.currentTarget.naturalHeight,
          }))
      }
    />
    {children}
  </div>
);
